var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d2-container',[_c('template',{slot:"header"},[_vm._v("基本示例")]),_c('d2-mde',{staticClass:"mde",model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}}),_c('el-card',{staticClass:"d2-card",attrs:{"shadow":"never"}},[_c('pre',[_vm._v(_vm._s(_vm.text))])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }